/* Brossange : JS minimal et différé (S03, C03, C04). Panier Ajax (Cart API) sérialisé, chouchou offert synchronisé
   et robuste (épuisé, onglets multiples), attribution de la visite en attributs de panier (stockage dans le navigateur
   seulement avec l'accord « Analyse »), fiche produit (finition,
   paliers, progression, barre d'achat, menu bas), galerie, onglets, questions, dialogues.
   Aucun prix n'est recalculé pour le paiement : les réductions automatiques Shopify font foi ; les montants affichés
   avant le panier viennent des paliers rendus par le thème. API globale : window.BrossangeCart.
   C18 : aucun texte ni nom de produit en dur. Textes de la langue (clé « js » de locales/*.json) lus dans le JSON
   #brossange-textes de la section cart-drawer, avec repli sur les textes français ci-dessous ; unité de la fiche
   (data-unite...) ou du panier ; cadeau reconnu par le réglage gift_product (window.Brossange.giftVariantId) ;
   montants au format et dans la devise du marché.
   C19 : maximum par article (réglage quantite_max_ligne, 10 par défaut) : au-delà, refus explicite sans requête. */
(() => {
  'use strict';

  const CONF = window.Brossange || {};
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const NB = String.fromCharCode(160);
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const safeColor = (value) => (/^#[0-9a-f]{3,8}$/i.test(String(value || '')) ? value : '');
  const poignee = (texte) => String(texte || '').toLowerCase()
    .replace(/[àâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[îï]/g, 'i').replace(/[ôö]/g, 'o').replace(/[ùûü]/g, 'u')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const calme = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* 0 bis. C18 : textes. Gabarits à crochets : [n], [i], [u] (unité), [U] (unité, initiale en capitale), [us] (pluriel),
     [art] (unité avec article défini), [prix], [ecart], [total], [code], [nom], [finition], [cadeau], [debut], [fin] ;
     suffixe _f ou _m selon le genre de l'unité ou du cadeau. Repli identique à locales/fr.default.json (test C18). */
  const DEFAUTS = {
    erreur_panier: 'Erreur panier', panier_label_one: 'Panier, [n] article', panier_label_other: 'Panier, [n] articles',
    echec_ajout_f: 'Cette [u] n\'a pas pu être ajoutée.', echec_ajout_m: 'Ce [u] n\'a pas pu être ajouté.', echec_ajout_fiche_f: 'Cette [u] n\'a pas pu être ajoutée. Réessayez ou écrivez-nous.',
    echec_ajout_fiche_m: 'Ce [u] n\'a pas pu être ajouté. Réessayez ou écrivez-nous.', connexion: 'La connexion a coupé. Réessayez dans un instant.', aucun_article: 'Aucun article à ajouter.',
    ajoutee_f: '[U] ajoutée au panier.', ajoutee_m: '[U] ajouté au panier.', ajoutees_f: '[n] [us] ajoutées au panier.',
    ajoutees_m: '[n] [us] ajoutés au panier.', panier_maj: 'Panier mis à jour\u00a0: [n] [unites], [total].', article_retire: 'Article retiré du panier.',
    code_retire: 'Code retiré.', code_vide: 'Il manque le code promo.', code_applique: 'Code [code] appliqué.',
    code_refuse: 'Ce code n\'existe pas ou a expiré.', message_cadeau: 'Le message n\'a pas pu être enregistré. Il partira avec le bouton Commander.', emplacement_legende_f: 'Finition de la [u] [i]',
    emplacement_legende_m: 'Finition du [u] [i]', emplacement: '[U] [i]', meme_finition_f: 'Même finition pour toutes',
    meme_finition_m: 'Même finition pour tous', epuisee: ', épuisée', meilleur: 'Meilleur prix atteint\u00a0: [prix] [art].',
    ajoutez: 'Ajoutez 1 [u]\u00a0: [ecart] de plus', cadeau_et_f: 'et [cadeau] offerte', cadeau_et_m: 'et [cadeau] offert',
    soit: 'Soit [prix] [art]', livraison_offerte: 'livraison offerte', passer: 'Passer à [n] [us]',
    ajouter: 'Ajouter au panier, [prix]', ajouter_n: 'Ajouter au panier, [n] [us], [prix]', bientot: 'Bientôt de retour',
    pack: 'Pack [nom]\u00a0: choisissez la finition de chaque [u].', barre_n: '[n] [us]', barre_1: '[finition], 1 [u]',
    toutes_en_f: 'Toutes les [us] en [finition].', toutes_en_m: 'Tous les [us] en [finition].', meme_finition_repli: 'même finition',
    selectionnees_f: '[n] [us] sélectionnées.', selectionnees_m: '[n] [us] sélectionnés.', finition_epuisee: 'Cette finition est épuisée pour le moment\u00a0: choisissez-en une autre ou demandez une alerte.',
    livraison_estimee: 'Livraison estimée entre le [debut] et le [fin].',
    quantite_max: 'Quantité limitée à [n] par article. Pour une commande plus importante, écrivez-nous.'
  };
  const TEXTES = (() => {
    try {
      const el = document.getElementById('brossange-textes');
      const t = el ? JSON.parse(el.textContent) : {};
      return t && typeof t === 'object' ? t : {};
    } catch (e) { return {}; }
  })();
  // Le filtre t de Shopify peut échapper les apostrophes : texte rendu tel qu'affiché
  const entites = (s) => String(s).replace(/&(#39|#x27|quot|amp|lt|gt);/g, (_, e) => ({ '#39': "'", '#x27': "'", quot: '"', amp: '&', lt: '<', gt: '>' }[e]));
  const tx = (cle, vars = {}) => {
    const modele = entites(typeof TEXTES[cle] === 'string' ? TEXTES[cle] : (DEFAUTS[cle] || ''));
    return modele.replace(/\[(\w+)\]/g, (m, k) => (Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m));
  };
  const maj = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');
  // Unité « singulier|pluriel|article|genre » rendue par le snippet product-unite
  const unite = (brut, repli) => {
    const [s, p, a, g] = entites(brut || repli).split('|');
    return { s, p: p || s, a: a || s, g: g === 'm' ? 'm' : 'f' };
  };
  const UNITE_PANIER = unite(TEXTES._unite, 'brosse|brosses|la brosse|f');
  const CADEAU = unite(TEXTES._cadeau, 'chouchou|chouchous|le chouchou|m');

  /* 0 ter. C19 : maximum par article, toutes lignes confondues, rendu par le tiroir (data-qte-max, data-quantites
     « id:quantité; ») ; texte de la langue (clé quantite_max) sinon repli */
  const REPLI_QTE_MAX = 'Quantité limitée à [n] par article. Pour une commande plus importante, écrivez-nous.';
  const texteQteMax = (n) => tx('quantite_max', { n });
  const panierRendu = () => ($('[data-cart-content]') || { dataset: {} }).dataset;
  const qteMax = () => { const n = Math.floor(Number(panierRendu().qteMax)); return n >= 1 ? n : 10; };
  const quantitesPanier = () => {
    const out = {};
    String(panierRendu().quantites || '').split(';').forEach((p) => { const [id, q] = p.split(':'); if (id && q > 0) out[id] = (out[id] || 0) + Number(q); });
    return out;
  };
  // Articles au-delà du maximum avec les quantités demandées ({ id: quantité })
  const depassements = (d) => { const max = qteMax(); const deja = quantitesPanier(); return Object.keys(d).filter((id) => (deja[id] || 0) + d[id] > max); };

  /* 0. Stockage du navigateur, protégé : navigation privée ou stockage bloqué ne cassent rien */
  const stockage = (nom) => {
    try {
      const s = window[nom];
      s.setItem('__brossange', '1');
      s.removeItem('__brossange');
      return s;
    } catch (e) { return null; }
  };
  const LS = stockage('localStorage');
  const SS = stockage('sessionStorage');
  const lire = (s, cle) => { try { return s ? s.getItem(cle) : null; } catch (e) { return null; } };
  const ecrire = (s, cle, valeur) => { try { if (s) s.setItem(cle, valeur); } catch (e) { /* quota ou blocage */ } };
  const effacer = (s, cle) => { try { if (s) s.removeItem(cle); } catch (e) { /* blocage */ } };

  /* 1. Format monétaire : 24,90 € (espace insécable), le format de la boutique met le symbole devant. C18 :
     séparateurs lus dans un exemple rendu par Shopify pour la devise du marché (1.234,56 ; 1'234.56) et suffixe
     du marché (espace insécable et € ou code ISO), comme dans le Liquid (snippet product-devise) */
  const formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const exemple = entites(TEXTES._exemple || '1.234,56');
    const avecDecimales = exemple.match(/^1(\D?)234(\D)56$/);
    const sansDecimales = exemple.match(/^1(\D?)23[45]$/);
    const milliers = (avecDecimales || sansDecimales || [])[1] || '';
    const decimal = avecDecimales ? avecDecimales[2] : ',';
    const suffixe = typeof TEXTES._suffixe === 'string' ? entites(TEXTES._suffixe) : `${NB}€`;
    const [ent, dec] = value.toFixed(sansDecimales ? 0 : 2).split('.');
    const groupe = ent.replace(/\B(?=(\d{3})+(?!\d))/g, milliers);
    return (dec ? groupe + decimal + dec : groupe) + suffixe;
  };

  /* 1 bis. Événements du thème pour les pixels Shopify (Customer Events), sans donnée personnelle. C12 : file commune
     lue par brossange-track.js, qui ne publie qu'avec l'accord « Analyse » (file gardée avant le choix, jetée au refus) */
  const publier = (nom, data) => {
    try { (window.brossangeQ = window.brossangeQ || []).push([nom, data]); } catch (e) { /* suivi facultatif */ }
  };

  /* 2. Annonces : région du dialogue ouvert (le reste de la page est inerte pendant un dialogue modal), sinon de la page */
  const announce = (text) => {
    const live = $('dialog[open] [data-live]') || $('#live-region');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = text; }, 50);
  };

  /* 3. API panier : une requête à la fois (file d'attente), pour éviter les doublons de chouchou et les courses */
  let queue = Promise.resolve();
  const enqueue = (task) => {
    const run = queue.then(task, task);
    queue = run.catch(() => {});
    return run;
  };
  const request = async (path, body) => {
    const res = await fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    });
    const texte = await res.text();
    let data = null;
    try { data = JSON.parse(texte); } catch (e) { data = null; }
    // Réponse HTML (vérification anti robot, coupure) : traitée comme une erreur réseau, jamais comme un panier
    if (!res.ok || !data || typeof data !== 'object') {
      const err = new Error((data && (data.description || data.message)) || tx('erreur_panier'));
      err.status = res.ok ? 0 : res.status;
      throw err;
    }
    return data;
  };
  const getCart = () => request('cart.js');

  /* 4. Chouchou offert : ajouté dès le seuil de brosses s'il est disponible, retiré en dessous, une seule ligne en
     quantité 1. Un refus d'ajout (422) est gardé un quart d'heure dans la session (stockage fonctionnel du panier) :
     pendant ce délai, aucun nouvel essai même si la page annonce le chouchou disponible ; ensuite, la disponibilité
     lue au rendu de la page fait foi (retour en stock), avec au plus un essai par quart d'heure. */
  const CLE_EPUISE = 'brossange-chouchou-epuise';
  const DUREE_CONSTAT = 15 * 60000;
  const tiroir = $('#cart-drawer');
  const constatEpuise = Number(lire(SS, CLE_EPUISE)) || 0;
  let cadeauEpuise = constatEpuise > 0 && Date.now() - constatEpuise < DUREE_CONSTAT;
  if (constatEpuise && !cadeauEpuise) effacer(SS, CLE_EPUISE);
  const cadeauDisponible = () => !(tiroir && tiroir.dataset.giftAvailable === 'false') && !cadeauEpuise;
  const isGift = (item) => String(item.variant_id) === String(CONF.giftVariantId);
  const countBrushes = (cart) => (cart.items || [])
    .filter((item) => !isGift(item))
    .filter((item) => !CONF.countType || item.product_type === CONF.countType)
    .reduce((sum, item) => sum + item.quantity, 0);

  const syncGift = async (cart) => {
    if (!CONF.giftVariantId || !cart || !Array.isArray(cart.items)) return cart;
    const threshold = Number(CONF.giftThreshold) || 2;
    const brushes = countBrushes(cart);
    // Toutes les lignes de chouchou (propriétés différentes possibles si le panier a été forcé)
    const gifts = cart.items.filter(isGift);
    const giftQty = gifts.reduce((sum, item) => sum + item.quantity, 0);
    if (brushes >= threshold && !gifts.length) {
      if (!cadeauDisponible()) return cart;
      try {
        await request('cart/add.js', { items: [{ id: Number(CONF.giftVariantId), quantity: 1, properties: { _cadeau: 'offert' } }] });
      } catch (err) {
        // Épuisé entre deux pages : plus d'essai pendant un quart d'heure, le panier affiche un message honnête
        if (err.status === 422) {
          cadeauEpuise = true;
          ecrire(SS, CLE_EPUISE, String(Date.now()));
          return cart;
        }
        throw err;
      }
      publier('brossange_gift_added', { nb_brosses: brushes });
      return getCart();
    }
    // Une seule requête par clé de ligne : la première ligne garde 1 chouchou, les autres passent à 0
    if (brushes >= threshold && giftQty !== 1) {
      const updates = {};
      gifts.forEach((g, i) => { updates[g.key] = i === 0 ? 1 : 0; });
      return request('cart/update.js', { updates });
    }
    if (brushes < threshold && gifts.length) {
      const updates = {};
      gifts.forEach((g) => { updates[g.key] = 0; });
      return request('cart/update.js', { updates });
    }
    return cart;
  };

  /* 5. Attribution (C13) : assets/brossange-attribution.js, chargé avant ce fichier, garde la première et la dernière
     visite (cookie propriétaire, seulement avec l'accord « Analyse ») et calcule les attributs cachés du panier. Ce
     fichier les écrit dans sa file d'attente après chaque mise à jour du panier et les joint au formulaire de paiement.
     Module absent (fichier bloqué par une extension du navigateur ou non chargé) : règle de C04, paramètres UTM de
     l'adresse de la page en cours seulement, rien n'est lu ni gardé. Les anciennes clés du navigateur (C04) sont
     effacées. */
  effacer(LS, 'brossange-utm');
  effacer(SS, 'brossange-landing');
  const UTM_SECOURS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const secours = () => {
    const out = {};
    try {
      const propre = (v) => Array.from(String(v || '')).filter((c) => c.charCodeAt(0) >= 32 && !'<>"\'`'.includes(c)).join('').trim().slice(0, 120);
      const params = new URLSearchParams(window.location.search);
      UTM_SECOURS.forEach((k) => { const v = propre(params.get(k)); if (v) out[`_${k}`] = v; });
      if (Object.keys(out).length) out._landing = propre(window.location.pathname) || '/';
    } catch (e) { /* adresse illisible */ }
    return out;
  };
  const attributsVoulus = (cart) => {
    try {
      const a = window.BrossangeAttribution;
      return a && typeof a.attributs === 'function' ? a.attributs(cart) : secours();
    } catch (e) { return {}; }
  };
  const analyseAutorisee = () => {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  };
  // Une valeur vide efface une clé présente ; une clé absente et vide n'est jamais envoyée
  const ecarts = (voulus, actuels) => {
    const diff = {};
    Object.keys(voulus).forEach((k) => { if (((actuels || {})[k] || '') !== voulus[k]) diff[k] = voulus[k]; });
    return diff;
  };
  // Intégration V2, voie A (budget JS) : brossange-attribution.js n'est chargé qu'avec l'accord « Analyse », ou pour
  // traiter le retrait d'un accord donné plus tôt (cookie brossange_source présent) ; sinon la règle de secours s'applique
  let attributionDemandee = false;
  const cookieAttribution = () => { try { return /(?:^|;\s*)brossange_source=/.test(document.cookie); } catch (e) { return false; } };
  const chargerAttribution = () => {
    if (attributionDemandee || window.BrossangeAttribution || !(analyseAutorisee() || cookieAttribution())) return;
    const balise = document.querySelector('script[data-attribution]');
    const url = balise && balise.dataset.attribution;
    if (!url) return;
    attributionDemandee = true;
    const s = document.createElement('script');
    s.src = url;
    s.async = true;
    document.head.appendChild(s);
  };
  document.addEventListener('visitorConsentCollected', chargerAttribution);
  chargerAttribution();
  if (!attributionDemandee) {
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (erreur) => { if (!erreur) chargerAttribution(); });
      }
    } catch (e) { /* API absente : règle de secours */ }
  }
  const attribuer = async (cart) => {
    if (!cart || !cart.item_count) return cart;
    const diff = ecarts(attributsVoulus(cart), cart.attributes);
    if (!Object.keys(diff).length) return cart;
    try { return await request('cart/update.js', { attributes: diff }); } catch (e) { return cart; }
  };

  /* 6. Rendu du tiroir et de la page panier par la Section Rendering API */
  const remplacerTiroir = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-content]');
    const current = $('[data-cart-content]');
    if (!next || !current) return;
    const active = document.activeElement;
    const focusKey = active && current.contains(active)
      ? ['data-line-qty', 'data-line-remove', 'data-upsell-add', 'data-code-remove'].find((a) => active.hasAttribute(a))
      : null;
    const keyValue = focusKey && active.dataset.key;
    // Bouton « - » ou « + » : le focus revient sur le même bouton (deux Entrée sur « + » ajoutent deux brosses)
    const sens = focusKey && active.dataset.sens;
    current.replaceWith(next);
    if (focusKey) {
      const filtreSens = sens ? `[data-sens="${CSS.escape(sens)}"]` : '';
      const target = (keyValue && next.querySelector(`[${focusKey}]${filtreSens}[data-key="${CSS.escape(keyValue)}"]`))
        || next.querySelector('[data-dialog-close]');
      if (target) target.focus();
    }
    if (cadeauEpuise) $$('[data-gift-epuise]').forEach((el) => { el.hidden = false; });
    voirUpsell('tiroir');
  };
  const remplacerPagePanier = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-main-cart]');
    const current = $('[data-main-cart]');
    if (next && current) current.replaceWith(next);
    if (cadeauEpuise) $$('[data-gift-epuise]').forEach((el) => { el.hidden = false; });
  };
  const renderDrawer = async () => {
    const pagePanier = $('[data-main-cart]');
    const idPage = pagePanier && pagePanier.dataset.sectionId;
    const ids = ['cart-drawer'].concat(idPage ? [idPage] : []);
    const base = idPage ? window.location.pathname : ROOT;
    const res = await fetch(`${base}?sections=${ids.map(encodeURIComponent).join(',')}`, { credentials: 'same-origin' });
    if (!res.ok) return;
    let data = null;
    try { data = await res.json(); } catch (e) { return; }
    remplacerTiroir(data['cart-drawer']);
    if (idPage) remplacerPagePanier(data[idPage]);
  };

  const updateCounts = (cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
    $$('[data-cart-label]').forEach((el) => {
      el.setAttribute('aria-label', tx(cart.item_count > 1 ? 'panier_label_other' : 'panier_label_one', { n: cart.item_count }));
    });
  };

  /* 7. Synchronisation entre onglets : signal dans le stockage local, relecture quand l'onglet redevient visible */
  const CLE_SYNC = 'brossange-panier-maj';
  const signature = (cart) => (cart && Array.isArray(cart.items) ? cart.items.map((i) => `${i.key}:${i.quantity}`).join('|') : '');
  const signaler = () => ecrire(LS, CLE_SYNC, String(Date.now()));

  const refresh = () => enqueue(async () => {
    let cart = await getCart();
    const avant = signature(cart);
    cart = await syncGift(cart);
    if (signature(cart) !== avant) signaler();
    updateCounts(cart);
    await renderDrawer();
    return cart;
  });

  const mutate = (path, body) => enqueue(async () => {
    await request(path, body);
    let cart = await getCart();
    cart = await syncGift(cart);
    cart = await attribuer(cart);
    signaler();
    updateCounts(cart);
    await renderDrawer();
    return cart;
  });

  let panierPerime = false;
  let cacheDepuis = 0;
  window.addEventListener('storage', (event) => {
    if (event.key !== CLE_SYNC) return;
    if (document.visibilityState === 'visible') refresh().catch(() => {});
    else panierPerime = true;
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') { cacheDepuis = Date.now(); return; }
    // Autre onglet ou paiement terminé ailleurs : relecture si signalé, ou après une minute d'absence
    if (panierPerime || (cacheDepuis && Date.now() - cacheDepuis > 60000)) {
      panierPerime = false;
      cacheDepuis = 0;
      refresh().catch(() => {});
    }
  });

  /* 8. Dialogues : tiroir panier, menu mobile, zoom. Dialogue modal natif : focus contenu, Échap, retour du focus */
  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDialog = (dialog) => {
    if (!dialog || !dialog.open) return;
    dialog.close();
  };
  $$('dialog').forEach((dialog) => {
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(dialog); });
  });
  /* 8 bis. C12 : ouverture du tiroir (source : clic, ajout, externe) et impression de la brosse suivante, une fois
     par ouverture du tiroir (le contenu est rendu à nouveau à chaque mise à jour) et une fois sur la page panier */
  let upsellVu = false;
  const voirUpsell = (source) => {
    const zone = source === 'panier' ? $('[data-main-cart] [data-upsell]') : $('#cart-drawer[open] [data-upsell]');
    if (!zone || (source !== 'panier' && upsellVu)) return;
    if (source !== 'panier') upsellVu = true;
    const contenu = $('[data-cart-content]');
    publier('brossange_upsell_view', { source, nb_brosses: Number(contenu && contenu.dataset.brosses) || 0 });
  };
  if (tiroir) tiroir.addEventListener('close', () => { upsellVu = false; });
  const openCart = (source) => {
    const dialogue = $('#cart-drawer');
    if (dialogue && !dialogue.open) {
      const contenu = $('[data-cart-content]');
      publier('brossange_drawer_open', { source: typeof source === 'string' ? source : 'externe', nb_brosses: Number(contenu && contenu.dataset.brosses) || 0 });
    }
    openDialog(dialogue);
    voirUpsell('tiroir');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener) {
      event.preventDefault();
      openCart('clic');
      return;
    }
    const dialogOpener = event.target.closest('[data-dialog-open]');
    if (dialogOpener) {
      event.preventDefault();
      openDialog(document.getElementById(dialogOpener.dataset.dialogOpen));
      return;
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closeDialog(closer.closest('dialog'));
  });

  /* 9. Erreurs et état occupé du panier */
  const setBusy = (busy) => {
    const content = $('[data-cart-content]');
    if (content) content.setAttribute('aria-busy', busy ? 'true' : 'false');
  };
  const fail = (err) => {
    const msg = err && err.status === 422 ? (err.message || tx(`echec_ajout_${UNITE_PANIER.g}`, { u: UNITE_PANIER.s })) : tx('connexion');
    announce(msg);
    // Zones du tiroir et de la page panier (C19)
    $$('[data-cart-error]').forEach((box) => { box.textContent = msg; box.hidden = false; });
  };
  // C19 : refus du maximum (422, message explicite), suivi sans donnée saisie
  const refuserQteMax = () => {
    publier('brossange_form_error', { form: 'panier', champ: 'quantite', erreur: 'quantite_max', source: 'theme' });
    return Object.assign(new Error(texteQteMax(qteMax())), { status: 422, code: 'quantite_max' });
  };

  /* 10. Ajout au panier commun (fiche, packs, brosse suivante, menu bas, landings C07) */
  const ajouter = async (items, source = 'externe', infos = {}) => {
    const liste = (Array.isArray(items) ? items : [items]).map((i) => {
      const ligne = { id: Number(i && i.id), quantity: Math.max(1, Math.floor(Number(i && i.quantity) || 1)) };
      if (i && i.properties && typeof i.properties === 'object') ligne.properties = i.properties;
      return ligne;
    }).filter((l) => l.id > 0);
    if (!liste.length) {
      const err = new Error(tx('aucun_article'));
      err.status = 422;
      fail(err);
      throw err;
    }
    // C19 : au-delà du maximum par article, refus sans requête, message dans le tiroir ouvert (ou la page panier)
    const demandees = {};
    liste.forEach((l) => { demandees[l.id] = (demandees[l.id] || 0) + l.quantity; });
    if (depassements(demandees).length) {
      const err = refuserQteMax();
      if (!$('[data-main-cart]')) openCart('quantite-max');
      fail(err);
      throw err;
    }
    const nb = typeof infos.nb_brosses === 'number' ? infos.nb_brosses : liste.reduce((s, l) => s + l.quantity, 0);
    try {
      const cart = await mutate('cart/add.js', { items: liste });
      publier('brossange_add_to_cart', {
        source: String(source || 'externe').slice(0, 40),
        pack: infos.pack || null,
        nb_brosses: nb,
        total_centimes: typeof infos.total_centimes === 'number' ? infos.total_centimes : null
      });
      // Sur la page panier, la page est déjà rendue à nouveau : pas de tiroir par-dessus. Le tiroir s'ouvre avant
      // l'annonce : la région lue est alors celle du dialogue, la seule active pendant un dialogue modal
      // Achat immédiat : le paiement s'ouvre juste après, sans tiroir
      if (!$('[data-main-cart]') && !infos.sans_tiroir) openCart('ajout');
      const u = infos.unite || UNITE_PANIER;
      announce(nb > 1 ? tx(`ajoutees_${u.g}`, { n: nb, us: u.p }) : tx(`ajoutee_${u.g}`, { U: maj(u.s) }));
      return cart;
    } catch (err) {
      fail(err);
      throw err;
    }
  };

  /* 11. Fiches produit présentes : le bouton du menu bas valide le formulaire de la fiche (palier et finitions) */
  const formulaires = [];
  const formulaireFiche = (variantId) => {
    const trouve = formulaires.find((f) => f.ids.has(String(variantId)));
    return trouve ? trouve.form : null;
  };

  /* 12. Interactions du panier (délégation : le contenu est remplacé à chaque mise à jour) */
  document.addEventListener('click', async (event) => {
    const qtyBtn = event.target.closest('[data-line-qty]');
    const removeBtn = event.target.closest('[data-line-remove]');
    const upsell = event.target.closest('[data-upsell-add]');
    const removeCode = event.target.closest('[data-code-remove]');
    const quickAdd = event.target.closest('[data-quick-add]');
    if (!qtyBtn && !removeBtn && !upsell && !removeCode && !quickAdd) return;
    try {
      if (qtyBtn) {
        // C19 : « + » au maximum : refus sans requête
        if (qtyBtn.dataset.sens === 'plus' && qtyBtn.dataset.variante && depassements({ [qtyBtn.dataset.variante]: 1 }).length) {
          fail(refuserQteMax());
          return;
        }
        setBusy(true);
        const cart = await mutate('cart/change.js', { id: qtyBtn.dataset.key, quantity: Number(qtyBtn.dataset.lineQty) });
        const n = countBrushes(cart);
        announce(tx('panier_maj', { n, unites: n > 1 ? UNITE_PANIER.p : UNITE_PANIER.s, total: formatMoney(cart.total_price) }));
      } else if (removeBtn) {
        setBusy(true);
        await mutate('cart/change.js', { id: removeBtn.dataset.key, quantity: 0 });
        announce(tx('article_retire'));
      } else if (upsell) {
        setBusy(true);
        const zone = upsell.closest('[data-upsell]');
        // Groupe de radios propre à chaque bloc (tiroir ou page panier), cherché dans le bloc du bouton
        const choisi = zone && $('input[name^="upsell-finition"]:checked', zone);
        const contenu = $('[data-cart-content]');
        const avant = Number(contenu && contenu.dataset.brosses) || 0;
        const finition = choisi ? poignee(choisi.getAttribute('aria-label')) : '';
        await ajouter([{ id: Number(choisi ? choisi.value : upsell.dataset.upsellAdd), quantity: 1 }], 'upsell');
        publier('brossange_upsell_add', { nb_brosses_avant: avant, finition });
      } else if (removeCode) {
        setBusy(true);
        const remaining = (removeCode.dataset.remaining || '').split(',').map((c) => c.trim()).filter(Boolean).join(',');
        await mutate('cart/update.js', { discount: remaining });
        announce(tx('code_retire'));
      } else if (quickAdd) {
        event.preventDefault();
        const form = formulaireFiche(quickAdd.dataset.quickAdd);
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          return;
        }
        quickAdd.setAttribute('aria-busy', 'true');
        try {
          await ajouter([{ id: Number(quickAdd.dataset.quickAdd), quantity: 1 }], 'menu_bas', { nb_brosses: 1 });
        } finally {
          quickAdd.removeAttribute('aria-busy');
        }
      }
    } catch (err) {
      fail(err);
    } finally {
      setBusy(false);
    }
  });

  document.addEventListener('submit', async (event) => {
    const promo = event.target.closest('[data-promo-form]');
    if (!promo) return;
    event.preventDefault();
    const input = promo.querySelector('input[name="discount"]');
    const code = (input.value || '').trim();
    if (!code) {
      input.setAttribute('aria-invalid', 'true');
      announce(tx('code_vide'));
      publier('brossange_form_error', { form: 'code-promo', champ: 'discount', erreur: 'vide', source: 'theme' });
      return;
    }
    input.removeAttribute('aria-invalid');
    const existing = (promo.dataset.existing || '').split(',').map((c) => c.trim()).filter(Boolean);
    let message = '';
    try {
      setBusy(true);
      await enqueue(async () => {
        const res = await request('cart/update.js', { discount: existing.concat(code).join(',') });
        const entry = (res.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (entry && entry.applicable) {
          message = tx('code_applique', { code: entry.code });
          // C12 : résultat seulement, jamais le code saisi
          publier('brossange_code_promo', { resultat: 'applique' });
        } else {
          message = tx('code_refuse');
          publier('brossange_code_promo', { resultat: 'refuse' });
          await request('cart/update.js', { discount: existing.join(',') });
        }
        let cart = await getCart();
        cart = await syncGift(cart);
        signaler();
        updateCounts(cart);
        await renderDrawer();
      });
      const box = $('[data-promo-message]');
      if (box) box.textContent = message;
      announce(message);
    } catch (err) {
      fail(err);
    } finally {
      setBusy(false);
    }
  });

  /* 12 bis. Commander : les attributs d'attribution partent avec le formulaire (aucune requête de plus) */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('[data-checkout-form]');
    if (!form) return;
    // C19 : article au-delà du maximum, paiement refusé depuis le tiroir ; page panier : envoi refusé (12 quater)
    const max = qteMax();
    const trop = form.querySelector('input[name^="updates["]') ? controlerChampsQte(form)
      : (!event.submitter || event.submitter.name === 'checkout') && Object.values(quantitesPanier()).some((q) => q > max);
    if (trop) {
      event.preventDefault();
      refusChamp = Date.now();
      fail(refuserQteMax());
      return;
    }
    const conteneur = $('[data-cart-content]');
    let actuels = {};
    try { actuels = JSON.parse((conteneur && conteneur.dataset.attributs) || '{}') || {}; } catch (e) { actuels = {}; }
    const diff = ecarts(attributsVoulus(), actuels);
    Object.keys(diff).forEach((k) => {
      const nom = `attributes[${k}]`;
      let champ = $$('input[type="hidden"]', form).find((i) => i.name === nom);
      if (!champ) {
        champ = document.createElement('input');
        champ.type = 'hidden';
        champ.name = nom;
        form.appendChild(champ);
      }
      champ.value = diff[k];
    });
  }, true);

  /* 12 ter. Case cadeau et message : enregistrés au fil de la saisie (attributs de panier) */
  let minuteurCadeau = 0;
  const enregistrerCadeau = (zone) => {
    if (!zone) return;
    const caseCadeau = $('[data-cadeau-case]', zone);
    const message = $('[data-cadeau-message]', zone);
    const actif = !!(caseCadeau && caseCadeau.checked);
    const attributes = { Cadeau: actif ? 'Oui' : '', 'Message cadeau': actif && message ? message.value.trim().slice(0, 200) : '' };
    enqueue(() => request('cart/update.js', { attributes }))
      .then(() => signaler())
      .catch(() => announce(tx('message_cadeau')));
  };
  document.addEventListener('change', (event) => {
    const caseCadeau = event.target.closest && event.target.closest('[data-cadeau-case]');
    if (!caseCadeau) return;
    const zone = caseCadeau.closest('[data-cadeau]');
    const champ = zone && $('[data-cadeau-zone]', zone);
    const message = zone && $('[data-cadeau-message]', zone);
    if (champ) champ.hidden = !caseCadeau.checked;
    if (message) message.disabled = !caseCadeau.checked;
    enregistrerCadeau(zone);
  });
  document.addEventListener('input', (event) => {
    const message = event.target.closest && event.target.closest('[data-cadeau-message]');
    if (!message) return;
    window.clearTimeout(minuteurCadeau);
    minuteurCadeau = window.setTimeout(() => enregistrerCadeau(message.closest('[data-cadeau]')), 600);
  });

  /* 12 quater. C19 : page panier, maximum sur la somme des lignes d'un article (avec et sans pack), message du thème */
  const verifierChampQte = (champ) => {
    if (!champ || !champ.setCustomValidity) return false;
    const id = champ.dataset && champ.dataset.variante;
    const groupe = id && champ.form ? $$('input[name^="updates["]', champ.form).filter((c) => c.dataset.variante === id) : [champ];
    const n = Math.floor(Number(champ.dataset && champ.dataset.qteMax));
    const max = n >= 1 ? n : qteMax();
    const trop = groupe.reduce((s, c) => s + (Math.floor(Number(c.value)) || 0), 0) > max;
    groupe.forEach((c) => c.setCustomValidity(trop ? texteQteMax(max) : ''));
    return trop;
  };
  const controlerChampsQte = (form) => $$('input[name^="updates["]', form).map((c) => verifierChampQte(c)).some(Boolean);
  document.addEventListener('input', (event) => {
    const champ = event.target.closest && event.target.closest('input[name^="updates["]');
    if (champ) verifierChampQte(champ);
  });
  let refusChamp = 0;
  document.addEventListener('invalid', (event) => {
    const champ = event.target;
    if (!champ || !champ.name || champ.name.indexOf('updates[') !== 0) return;
    // Un seul message par envoi refusé, même si plusieurs champs dépassent
    if (verifierChampQte(champ) && Date.now() - refusChamp > 500) {
      refusChamp = Date.now();
      fail(refuserQteMax());
    }
  }, true);

  /* 13. Galerie : vues brosse en relief, photo et vidéo, vignettes, photo de la finition choisie, zoom */
  const vuesGalerie = (g) => ({ brosse: $('[data-vue-brosse]', g), photo: $('[data-vue-photo]', g), video: $('[data-vue-video]', g) });
  const afficherVue = (g, nom) => {
    const vues = vuesGalerie(g);
    Object.keys(vues).forEach((k) => { if (vues[k]) vues[k].hidden = k !== nom; });
    if (nom !== 'video') $$('video', g).forEach((v) => { try { v.pause(); } catch (e) { /* lecteur absent */ } });
  };
  const marquerVignette = (g, active) => $$('[data-thumb], [data-thumb-brosse], [data-thumb-video]', g)
    .forEach((t) => t.setAttribute('aria-current', String(t === active)));
  const poserPhoto = (g, thumb) => {
    const main = $('[data-vue-photo] img', g);
    if (main) {
      main.srcset = thumb.dataset.srcset || '';
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
    }
    const zoom = $('[data-zoom-image]', g);
    if (zoom) { zoom.src = thumb.dataset.zoom || thumb.dataset.src; zoom.alt = thumb.dataset.alt || ''; }
  };
  const defilerVers = (thumb) => {
    const bande = thumb.parentElement;
    if (!bande || bande.scrollWidth <= bande.clientWidth) return;
    const ecart = thumb.getBoundingClientRect().left - bande.getBoundingClientRect().left;
    bande.scrollBy({ left: ecart - (bande.clientWidth - thumb.clientWidth) / 2, behavior: calme.matches ? 'auto' : 'smooth' });
  };
  // Changement de finition : la photo principale devient le média de la variante (la brosse en relief se repeint seule)
  const montrerMediaVariante = (g, mediaId) => {
    if (!g || !mediaId) return;
    const thumb = $(`[data-thumb][data-media-id="${Number(mediaId)}"]`, g);
    if (!thumb) return;
    poserPhoto(g, thumb);
    const photo = $('[data-vue-photo]', g);
    if (photo && !photo.hidden) {
      marquerVignette(g, thumb);
      defilerVers(thumb);
    }
  };

  document.addEventListener('click', (event) => {
    const relief = event.target.closest('[data-thumb-brosse]');
    const thumb = event.target.closest('[data-thumb]');
    const video = event.target.closest('[data-thumb-video]');
    const cible = relief || thumb || video;
    if (!cible) return;
    const g = cible.closest('[data-gallery]');
    if (!g) return;
    if (relief) {
      afficherVue(g, 'brosse');
    } else if (thumb) {
      poserPhoto(g, thumb);
      afficherVue(g, 'photo');
    } else {
      const vue = $('[data-vue-video]', g);
      const modele = $('[data-video-modele]', g);
      if (vue && modele && !vue.firstElementChild) vue.appendChild(modele.content.cloneNode(true));
      afficherVue(g, 'video');
      const lecteur = vue && $('video', vue);
      if (lecteur) {
        const lecture = lecteur.play();
        if (lecture && lecture.catch) lecture.catch(() => {});
      }
    }
    marquerVignette(g, cible);
  });

  /* 14. Fiche produit : finition, paliers, progression, emplacements de couleurs, ajout, barre d'achat, menu bas */
  const initProductForm = (wrapper) => {
    const variantsEl = $('[data-variants]', wrapper);
    const form = $('form[action*="/cart/add"]', wrapper);
    if (!variantsEl || !form) return;
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!variants.length) return;
    const section = wrapper.closest('section') || document;
    const idInput = $('input[name="id"]', form);
    const submit = $('[data-add-button]', form);
    const submitLabel = $('[data-add-label]', form);
    const status = $('[data-form-status]', form);
    const slotsBox = $('[data-slots]', form);
    const acheterMaintenant = $('[data-buy-now]', form);
    let achatImmediat = false;
    const giftNotice = $('[data-gift-notice]', form);
    const soldout = $('[data-soldout]', wrapper);
    const packLabel = $('[data-pack-label]', form);
    const packsEl = $('[data-packs]', wrapper);
    const colorName = $('[data-color-name]', form);
    const colorEtat = $('[data-color-etat]', form);
    const progression = $('[data-progression]', form);
    const progressionTexte = $('[data-progression-texte]', form);
    const progressionBtn = $('[data-progression-btn]', form);
    const gallery = $('[data-gallery]', section);
    const barre = $('[data-buy-bar]', section);
    const cadeauActif = wrapper.dataset.cadeau === 'true';
    const seuilLivraison = Number(wrapper.dataset.seuilLivraison) || 0;
    // C18 : unité du produit et cadeau (attributs rendus par la fiche), sinon ceux du panier
    const U = {
      s: wrapper.dataset.unite || UNITE_PANIER.s,
      p: wrapper.dataset.unites || UNITE_PANIER.p,
      a: wrapper.dataset.uniteArticle || UNITE_PANIER.a,
      g: (wrapper.dataset.uniteGenre || UNITE_PANIER.g) === 'm' ? 'm' : 'f'
    };
    const G = { a: wrapper.dataset.cadeauArticle || CADEAU.a, g: (wrapper.dataset.cadeauGenre || CADEAU.g) === 'f' ? 'f' : 'm' };
    let packNames = {};
    try { packNames = packsEl ? JSON.parse(packsEl.textContent) : {}; } catch (e) { packNames = {}; }
    const threshold = Number(CONF.giftThreshold) || 2;
    const params = new URLSearchParams(window.location.search);
    let pack = params.get('pack') || '';
    if (pack && !/^[a-z0-9-]{1,60}$/.test(pack)) pack = '';

    formulaires.push({ form, ids: new Set(variants.map((v) => String(v.id))) });

    const current = () => variants.find((v) => String(v.id) === String(idInput.value)) || variants[0];
    const tiers = () => $$('input[type="radio"][name="quantity"]', form);
    const tierInput = () => $('input[type="radio"][name="quantity"]:checked', form);
    const quantity = () => {
      const champ = tierInput() || $('input[type="number"][name="quantity"]', form);
      return Math.max(1, Math.floor(Number(champ && champ.value) || 1));
    };
    const available = variants.filter((v) => v.available);

    // Finitions métal (D32) : pastille en dégradé ; sinon couleur du métachamp brossange.swatch ; sinon numéro
    const FINITIONS = { noir: 'noir', dore: 'dore', 'rose-dore': 'rose-dore', argente: 'argente' };
    const finitionDe = (titre) => FINITIONS[poignee(titre)] || '';
    const swatchesHTML = (slot, selectedId) => variants.map((v) => {
      const color = safeColor(v.swatch);
      const fin = finitionDe(v.title);
      return `
      <label class="swatch${fin ? ` finition--${fin}` : ''}${v.available ? '' : ' swatch--epuise'}" title="${esc(v.title)}">
        <input type="radio" name="slot-${slot}" value="${Number(v.id)}" data-track="fiche:finition-brosse" data-track-pos="${slot}" data-track-label="${fin || Number(v.position)}" ${String(v.id) === String(selectedId) ? 'checked' : ''} ${v.available ? '' : 'disabled'} aria-label="${esc(v.title)}${v.available ? '' : esc(tx('epuisee'))}">
        <span style="--c:${color || 'var(--paper-3)'}" aria-hidden="true">${color || fin ? '' : Number(v.position)}</span>
      </label>`;
    }).join('');

    const renderSlots = () => {
      if (!slotsBox) return;
      const n = quantity();
      if (n < 2) { slotsBox.hidden = true; slotsBox.innerHTML = ''; return; }
      const previous = $$('.slot input[type="radio"]:checked', slotsBox).map((input) => input.value);
      const base = available.length ? available : variants;
      const depart = current().available ? current() : base[0];
      const startIndex = Math.max(0, base.findIndex((v) => String(v.id) === String(depart.id)));
      const rows = [];
      for (let i = 0; i < n; i += 1) {
        // Couleurs différentes par défaut (une par brosse), modifiables une à une
        const selected = previous[i] || (i === 0 ? depart.id : base[(startIndex + i) % base.length].id);
        rows.push(`<fieldset class="slot"><legend class="visually-hidden">${esc(tx(`emplacement_legende_${U.g}`, { u: U.s, i: i + 1 }))}</legend><span aria-hidden="true">${esc(tx('emplacement', { U: maj(U.s), i: i + 1 }))}</span><div class="swatches swatches--mini">${swatchesHTML(i + 1, selected)}</div></fieldset>`);
      }
      slotsBox.innerHTML = `<button class="slots__meme" type="button" data-meme-finition data-track="fiche:meme-finition">${esc(tx(`meme_finition_${U.g}`))}</button>${rows.join('')}`;
      slotsBox.hidden = false;
    };

    const majProgression = (n) => {
      if (!progression || !progressionTexte) return;
      const radios = tiers();
      const actuel = radios.find((r) => Number(r.value) === n);
      const suivant = radios.find((r) => Number(r.value) === n + 1);
      if (!actuel) { progression.hidden = true; return; }
      if (!suivant) {
        progressionTexte.textContent = tx('meilleur', { prix: formatMoney(Number(actuel.dataset.perCents)), art: U.a });
        if (progressionBtn) progressionBtn.hidden = true;
      } else {
        const prixActuel = Number(actuel.dataset.priceCents);
        const prixSuivant = Number(suivant.dataset.priceCents);
        const avecCadeau = cadeauActif && n < threshold && n + 1 >= threshold;
        const livraison = seuilLivraison > 0 && prixActuel < seuilLivraison && prixSuivant >= seuilLivraison;
        // Même phrase que le Liquid (snippet product-paliers, textes fiche.progression)
        let phrase = tx('ajoutez', { u: U.s, ecart: formatMoney(prixSuivant - prixActuel) });
        if (avecCadeau) phrase += ` ${tx(`cadeau_et_${G.g}`, { cadeau: G.a })}`;
        phrase += `. ${tx('soit', { prix: formatMoney(Number(suivant.dataset.perCents)), art: U.a })}`;
        if (livraison) phrase += `, ${tx('livraison_offerte')}`;
        progressionTexte.textContent = `${phrase}.`;
        if (progressionBtn) {
          progressionBtn.hidden = false;
          progressionBtn.textContent = tx('passer', { n: n + 1, us: U.p });
          progressionBtn.dataset.cible = String(n + 1);
        }
      }
      progression.hidden = false;
    };

    const update = () => {
      const n = quantity();
      const tier = tierInput();
      const variant = current();
      const cents = tier ? Number(tier.dataset.priceCents) : variant.price * n;
      // Une brosse : la finition choisie doit être disponible ; plusieurs : au moins une finition disponible
      const vendable = n === 1 ? variant.available : available.length > 0;
      if (submitLabel) submitLabel.textContent = vendable ? tx('ajouter', { prix: formatMoney(cents) }) : tx('bientot');
      if (submit) submit.disabled = !vendable;
      if (soldout) soldout.hidden = variant.available;
      // C17 : l'alerte de retour en stock porte la finition choisie (étiquette alerte-<finition>, docs/emails/retour-en-stock.md)
      const alerteTags = soldout && soldout.querySelector('[data-alerte-tags]');
      if (alerteTags) alerteTags.value = `${alerteTags.dataset.alerteTags},alerte-${String(variant.option1 || variant.title).normalize('NFD').replace(/[^\w\s-]/g, '').trim().toLowerCase().replace(/\s+/g, '-')}`;
      if (colorEtat) colorEtat.hidden = variant.available;
      if (acheterMaintenant) acheterMaintenant.disabled = !vendable;
      if (giftNotice) giftNotice.classList.toggle('notice--active', cadeauActif && n >= threshold);
      if (colorName) colorName.textContent = variant.title;
      if (packLabel) {
        packLabel.hidden = !(pack && packNames[pack]);
        if (!packLabel.hidden) packLabel.textContent = tx('pack', { nom: packNames[pack], u: U.s });
      }
      majProgression(n);
      // Menu bas et barre d'achat : même prix et même action que le bouton principal
      $$('[data-quick-add]').forEach((lien) => {
        if (formulaireFiche(lien.dataset.quickAdd) !== form) return;
        const prix = $('[data-quick-price]', lien);
        if (prix) prix.textContent = formatMoney(cents);
        lien.setAttribute('aria-label', n > 1 ? tx('ajouter_n', { n, us: U.p, prix: formatMoney(cents) }) : tx('ajouter', { prix: formatMoney(cents) }));
      });
      if (barre) {
        const detail = $('[data-buy-bar-detail]', barre);
        const prix = $('[data-buy-bar-prix]', barre);
        const bouton = $('[data-buy-bar-btn]', barre);
        if (detail) detail.textContent = n > 1 ? tx('barre_n', { n, us: U.p }) : tx('barre_1', { finition: variant.title, u: U.s });
        if (prix) prix.textContent = formatMoney(cents);
        if (bouton) bouton.disabled = !vendable;
      }
    };

    const choisirPalier = (q, suivi) => {
      const radio = $(`input[type="radio"][name="quantity"][value="${q}"]`, form);
      if (!radio) return null;
      radio.checked = true;
      renderSlots();
      update();
      if (suivi) publier('brossange_select_pack', { nb_brosses: q, total_centimes: Number(radio.dataset.priceCents) || 0 });
      return radio;
    };

    form.addEventListener('change', (event) => {
      const target = event.target;
      if (target.name === 'option-1') {
        const variant = variants.find((v) => v.option1 === target.value);
        if (variant) {
          idInput.value = variant.id;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
          const match = $(`input[name="slot-1"][value="${variant.id}"]`, form);
          if (match && !match.disabled) match.checked = true;
          montrerMediaVariante(gallery, variant.media);
        }
        update();
      } else if (target.name === 'quantity') {
        pack = '';
        renderSlots();
        update();
        publier('brossange_select_pack', { nb_brosses: quantity(), total_centimes: Number(target.dataset.priceCents) || 0 });
      }
    });

    form.addEventListener('click', (event) => {
      const meme = event.target.closest('[data-meme-finition]');
      if (meme && slotsBox) {
        const premier = $('input[name="slot-1"]:checked', slotsBox);
        if (!premier) return;
        $$('.slot', slotsBox).forEach((slot) => {
          const radio = $(`input[value="${premier.value}"]`, slot);
          if (radio && !radio.disabled) radio.checked = true;
        });
        const v = variants.find((x) => String(x.id) === String(premier.value));
        announce(tx(`toutes_en_${U.g}`, { us: U.p, finition: v ? v.title : tx('meme_finition_repli') }));
        return;
      }
      const suivant = event.target.closest('[data-progression-btn]');
      if (suivant) {
        pack = '';
        const radio = choisirPalier(Number(suivant.dataset.cible), true);
        if (radio) announce(tx(`selectionnees_${U.g}`, { n: radio.value, us: U.p }));
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const n = quantity();
      const variant = current();
      if (n === 1 && !variant.available) {
        const msg = tx('finition_epuisee');
        if (status) status.textContent = msg;
        announce(msg);
        return;
      }
      const counts = new Map();
      if (n > 1 && slotsBox && !slotsBox.hidden) {
        const repli = variant.available ? variant : (available[0] || variant);
        for (let i = 1; i <= n; i += 1) {
          const picked = $(`input[name="slot-${i}"]:checked`, form);
          const id = picked ? picked.value : String(repli.id);
          counts.set(id, (counts.get(id) || 0) + 1);
        }
      } else {
        counts.set(String(variant.id), n);
      }
      const properties = pack ? { _pack: pack } : undefined;
      const items = Array.from(counts, ([id, qty]) => (properties ? { id: Number(id), quantity: qty, properties } : { id: Number(id), quantity: qty }));
      const tier = tierInput();
      if (submit) submit.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';
      const immediat = achatImmediat;
      achatImmediat = false;
      try {
        await ajouter(items, immediat ? 'achat_immediat' : (pack ? 'pack' : 'fiche'), { pack: pack || null, nb_brosses: n, total_centimes: tier ? Number(tier.dataset.priceCents) : null, unite: U, sans_tiroir: immediat });
        if (immediat) {
          // Addendum V2, décision 1 : le paiement Shopify affiche les paiements accélérés
          publier('brossange_achat_immediat', { nb_brosses: n, pack: pack || null });
          window.location.assign(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}checkout`);
          return;
        }
        if (status) status.textContent = n > 1 ? tx(`ajoutees_${U.g}`, { n, us: U.p }) : tx(`ajoutee_${U.g}`, { U: maj(U.s) });
      } catch (err) {
        // C19 : refus du maximum affiché tel quel
        if (status) status.textContent = err && err.code === 'quantite_max' ? err.message : tx(`echec_ajout_fiche_${U.g}`, { u: U.s });
      } finally {
        if (submit) submit.removeAttribute('aria-busy');
      }
    });

    // Acheter maintenant : même validation et même ajout que le bouton principal, puis le paiement
    if (acheterMaintenant) {
      acheterMaintenant.addEventListener('click', () => {
        if (acheterMaintenant.disabled) return;
        achatImmediat = true;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    // Liens de packs vers cette même fiche (cartes, tiroir vide) : le palier et le pack s'appliquent sans recharger
    document.addEventListener('click', (event) => {
      const lien = event.target.closest('a[href*="quantity="]');
      if (!lien || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      let url;
      try { url = new URL(lien.href, window.location.href); } catch (e) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      const q = Number(url.searchParams.get('quantity'));
      if (!(q >= 1) || !$(`input[type="radio"][name="quantity"][value="${q}"]`, form)) return;
      event.preventDefault();
      const p = url.searchParams.get('pack') || '';
      pack = /^[a-z0-9-]{1,60}$/.test(p) ? p : '';
      const dialogue = lien.closest('dialog');
      if (dialogue) closeDialog(dialogue);
      const radio = choisirPalier(q, true);
      const adresse = new URL(window.location.href);
      adresse.searchParams.set('quantity', String(q));
      if (pack) adresse.searchParams.set('pack', pack); else adresse.searchParams.delete('pack');
      window.history.replaceState({}, '', adresse);
      form.scrollIntoView({ behavior: calme.matches ? 'auto' : 'smooth', block: 'start' });
      const cibleFocus = $('[data-slots] input:checked', form) || radio;
      if (cibleFocus) cibleFocus.focus({ preventScroll: true });
    });

    // Barre d'achat collante (ordinateur) : visible quand le bouton principal est sorti par le haut de l'écran
    if (barre && submit && 'IntersectionObserver' in window) {
      const ordinateur = window.matchMedia('(min-width: 1024px)');
      let horsVue = false;
      const appliquer = () => { barre.hidden = !(horsVue && ordinateur.matches); };
      new IntersectionObserver((entrees) => {
        const e = entrees[entrees.length - 1];
        horsVue = !e.isIntersecting && e.boundingClientRect.top < 0;
        appliquer();
      }).observe(submit);
      if (ordinateur.addEventListener) ordinateur.addEventListener('change', appliquer);
    }

    /* Préremplissage depuis les cartes packs : ?quantity=2&pack=duo-copines */
    const preset = Number(params.get('quantity'));
    if (preset >= 1) {
      const radio = $(`input[type="radio"][name="quantity"][value="${preset}"]`, form);
      if (radio) radio.checked = true;
    }
    renderSlots();
    update();
  };
  $$('[data-product-form]').forEach(initProductForm);

  /* 15. Fourchette de livraison datée, dans l'unité du délai affiché (métachamp brossange.displayed_delay, lu aussi
     par le bloc livraison, le panier, la FAQ et les CGV) : « 8 à 12 jours » se compte en jours calendaires ;
     « 8 à 12 jours ouvrés » se compte sans week-end ni jour férié. Le texte et les dates ne divergent jamais. */
  const paques = (an) => {
    const a = an % 19; const b = Math.floor(an / 100); const c = an % 100;
    const d = Math.floor(b / 4); const e = b % 4; const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3); const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4); const k = c % 4; const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mois = Math.floor((h + l - 7 * m + 114) / 31);
    const jour = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(an, mois - 1, jour);
  };
  const cleJour = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  const feriesCache = {};
  const feries = (an) => {
    if (feriesCache[an]) return feriesCache[an];
    const p = paques(an);
    const decale = (n) => { const d = new Date(p); d.setDate(d.getDate() + n); return d; };
    feriesCache[an] = new Set([
      new Date(an, 0, 1), decale(1), new Date(an, 4, 1), new Date(an, 4, 8), decale(39), decale(50),
      new Date(an, 6, 14), new Date(an, 7, 15), new Date(an, 10, 1), new Date(an, 10, 11), new Date(an, 11, 25)
    ].map(cleJour));
    return feriesCache[an];
  };
  const ouvre = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !feries(d.getFullYear()).has(cleJour(d));
  const ajouterJours = (depart, n, ouvres) => {
    const d = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
    let reste = Number(n);
    while (reste > 0) {
      d.setDate(d.getDate() + 1);
      if (!ouvres || ouvre(d)) reste -= 1;
    }
    return d;
  };
  $$('[data-livraison-estimee]').forEach((el) => {
    const delai = String(el.dataset.delai || '');
    const m = delai.match(/(\d+)\s*(?:à|a)\s*(\d+)\s*jours/);
    if (!m) return;
    const ouvres = /ouvr/i.test(delai);
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
    const maintenant = new Date();
    el.textContent = tx('livraison_estimee', { debut: fmt.format(ajouterJours(maintenant, m[1], ouvres)), fin: fmt.format(ajouterJours(maintenant, m[2], ouvres)) });
    el.hidden = false;
  });

  /* 16. Onglets accessibles (le bon geste) : flèches, Début, Fin, un seul onglet tabulable */
  $$('[data-onglets]').forEach((liste) => {
    const onglets = $$('[role="tab"]', liste);
    const activer = (onglet, focus, suivi) => {
      onglets.forEach((t) => {
        const actif = t === onglet;
        t.setAttribute('aria-selected', String(actif));
        t.tabIndex = actif ? 0 : -1;
        const panneau = document.getElementById(t.getAttribute('aria-controls'));
        if (panneau) panneau.hidden = !actif;
      });
      if (focus) onglet.focus();
      if (suivi) publier('brossange_texture_tab', { texture: onglet.dataset.texture || '' });
    };
    liste.addEventListener('click', (event) => {
      const onglet = event.target.closest('[role="tab"]');
      if (onglet && onglet.getAttribute('aria-selected') !== 'true') activer(onglet, false, true);
    });
    liste.addEventListener('keydown', (event) => {
      const i = onglets.indexOf(document.activeElement);
      if (i < 0) return;
      let j = -1;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') j = (i + 1) % onglets.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') j = (i - 1 + onglets.length) % onglets.length;
      else if (event.key === 'Home') j = 0;
      else if (event.key === 'End') j = onglets.length - 1;
      if (j < 0) return;
      event.preventDefault();
      activer(onglets[j], true, true);
    });
  });

  /* 17. Questions : ouverture suivie (fiche et page FAQ), sans donnée personnelle */
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    const zone = d.closest('[data-faq]');
    const source = zone ? zone.dataset.faq : (d.id && d.id.indexOf('q-') === 0 ? 'faq' : '');
    if (!source) return;
    const resume = d.querySelector('summary');
    publier('brossange_faq_open', { source, question: d.dataset.question || d.id || (resume ? resume.textContent.trim().slice(0, 80) : '') });
  }, true);

  /* 18. Bandeau d'offre : masqué à l'échéance même si la page est en cache */
  $$('[data-ends-at]').forEach((el) => {
    const end = Date.parse(el.dataset.endsAt);
    if (!Number.isNaN(end) && end <= Date.now()) el.hidden = true;
  });

  /* 19. Cohérence du panier au chargement : une requête seulement si le chouchou doit changer. Motif rendu par le
     tiroir : « ajout », « quantite » (plusieurs chouchous), « retrait », sinon « non ». Un ajout déjà refusé dans le
     dernier quart d'heure n'est pas retenté : aucune lecture du panier, seulement le message honnête. */
  const contenu = $('[data-cart-content]');
  const motifSync = contenu ? contenu.dataset.giftSync : 'non';
  if (motifSync === 'ajout' && cadeauEpuise) $$('[data-gift-epuise]').forEach((el) => { el.hidden = false; });
  else if (motifSync === 'ajout' || motifSync === 'quantite' || motifSync === 'retrait') refresh().catch(() => {});
  else if (cadeauEpuise) $$('[data-gift-epuise]').forEach((el) => { el.hidden = false; });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh().catch(() => {}); });

  /* 20. Pages S04 : anti-spam du contact, cookies, impression, FAQ par ancre, CTA du hero */
  document.addEventListener('submit', (event) => {
    const piege = event.target.querySelector && event.target.querySelector('input[name="contact[site_web]"]');
    if (piege && piege.value.trim() !== '') event.preventDefault();
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cookies]')) {
      event.preventDefault();
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    }
    if (event.target.closest('[data-print]')) {
      event.preventDefault();
      window.print();
    }
    const cta = event.target.closest('.hero .btn, .final .btn');
    if (cta) publier('brossange_cta', { source: cta.closest('.hero') ? 'hero' : 'final', libelle: cta.textContent.trim().slice(0, 60) });
  });

  const ouvrirAncre = () => {
    const id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id) return;
    const cible = document.getElementById(id);
    if (!cible) return;
    let details = cible.tagName === 'DETAILS' ? cible : null;
    if (!details && cible.classList.contains('faq-groupe__titre')) details = cible.parentElement.querySelector('details');
    if (details) {
      details.open = true;
      details.scrollIntoView({ block: 'start' });
      const resume = details.querySelector('summary');
      if (resume) resume.focus({ preventScroll: true });
    }
  };
  ouvrirAncre();
  window.addEventListener('hashchange', ouvrirAncre);

  /* 20 bis. C12 : brosse suivante proposée sur la page panier (impression) */
  voirUpsell('panier');

  /* 21. API globale : ajouter(items, source) ajoute, synchronise le chouchou, publie brossange_add_to_cart et ouvre
     le tiroir (items = [{ id, quantity, properties }]). Promesse rejetée en cas d'erreur, message déjà affiché. */
  window.BrossangeCart = {
    ajouter: (items, source, infos) => ajouter(items, source || 'externe', infos || {}),
    refresh,
    getCart,
    formatMoney,
    // C18 : textes de la langue (clé « js » des locales) pour les scripts des landings et des pages
    texte: tx,
    ouvrir: () => openCart('externe'),
    // Accord « Analyse » de la bannière native (C07 : même règle pour brossange_attribution)
    analyseAutorisee,
    // C13 : écriture d'attributs dans la file d'attente du panier (brossange-attribution.js)
    ecrireAttributs: (attributes) => enqueue(() => request('cart/update.js', { attributes }))
  };
  document.dispatchEvent(new CustomEvent('brossange:panier-pret'));
})();
